import { forwardRef } from 'react';
import { CustomButton } from '../../../../features/customButton';
import classNames from 'classnames';
import { defaultStore, stores } from '../../../../../translations';

const Item = forwardRef(({ action, buttonLogic = {}, isHidden = false, className, img, shadow, isFly }, ref) => {
  return (
    <div
      ref={(currentRef) => ref && (ref.current[action] = currentRef)}
      key={action}
      className={classNames('interactive-shop__item', `interactive-shop__item_${action}`, {
        'interactive-shop__item_hidden': isHidden,
        [`interactive-shop__item_${action}-${defaultStore}`]: defaultStore === stores.kz,
      })}
    >
      <CustomButton className={classNames(className, { 'interactive-shop__item-button_fly': isFly })} {...buttonLogic}>
        {img && <img src={img} alt={action} />}
      </CustomButton>
      {!isHidden && shadow && (
        <div className={'interactive-shop__item-shadow'}>
          <img src={shadow} />
        </div>
      )}
    </div>
  );
});

export default Item;
